import Information from '@/components/admin/company/Information';
import React from 'react';

const CompanyInformation = () => {
  return <Information />;
};

export default CompanyInformation;
